module.exports = __webpack_public_path__ + "img/voix-des-pierres.0e15a10b.png";